import api from '../../api/client';
import { useState, useEffect } from "react";
import { format } from "date-fns";
import axios from "axios";
import config from "../../config";
import { Row, Col, Card, Statistic, Spin } from "antd";
import { CalendarOutlined, HourglassOutlined } from "@ant-design/icons";

const MonthlySummary = ({ userId }) => {
  const [summary, setSummary] = useState(null);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    const month = format(new Date(), "yyyy-MM");
    axios
      .get(`/hr/attendance/summary?month=${month}`)
      .then((response) => {
        const userSummary = response.data.find(
          (item) => item.user_id === userId,
        );
        setSummary(userSummary);
      })
      .catch((error) => {
        console.error("Error fetching summary:", error);
      });
  }, [userId]);

  if (!summary) {
    return (
      <div className="text-center my-4">
        <Spin size="large" />
        <div>Loading summary...</div>
      </div>
    );
  }

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12}>
        <Card hoverable className="shadow-sm">
          <Statistic
            title="Days Present"
            value={summary.days_present}
            valueStyle={{ color: "#1890ff" }}
            prefix={<CalendarOutlined />}
          />
        </Card>
      </Col>
      <Col xs={24} md={12}>
        <Card hoverable className="shadow-sm">
          <Statistic
            title="Total Hours"
            value={summary.total_hours}
            valueStyle={{ color: "#52c41a" }}
            prefix={<HourglassOutlined />}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default MonthlySummary;
